<template>

  <div
  class="lista-allenamenti"
  >
  <div class="lista-allenamenti__content">
    <div
    class="loading-container"
    :class="{
      'loading': loading
      }">

      <div class="loading-pending">
        <p>loading...</p>
      </div>

      <div class="loading-complete">
        <p v-if="allenamenti.length">Seleziona fra questi allenamenti.</p>
        <p v-else>Non ci sono allenamenti per questo periodo.</p>
        <v-list>
<template
v-for="(allenamento, index) in allenamenti"
>

          <v-list-item
:class="classAllenamento(allenamento)"
:key="allenamento.id"
          @click="select(allenamento)"
          >
          <v-list-item-content>
            <v-list-item-subtitle >
              <strong>{{formatData(allenamento.data)}}</strong>
            </v-list-item-subtitle>
            <v-list-item-title >
              {{allenamento.titolo || allenamento.descrizione || allenamento.sport_descrizione}}
              <i v-if="isAssociato(allenamento)" class="msp-icon-link-1 catenella"></i>
            </v-list-item-title>
            <v-list-item-subtitle >
              {{allenamento.sport_descrizione}}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
<v-divider
v-if="index < allenamenti.length -1"
:key="'divider-'+allenamento.id"

></v-divider>
      </template>

      </v-list>

      <div class="more" v-if="!more">
        <v-btn text block @click="setMore">Anche settimana successiva</v-btn>
      </div>

    </div>
  </div>

  <msp-confirm ref="confirmAssocia"></msp-confirm>

</div><!--content-->
</div>

</template>

<script>
import allenamentoCalcoli from "@src/js/vue/mixins/allenamentoCalcoli.js";
import { makeRange } from "@src/js/vue/mixins/helperAssociazioneAttivita.js";
import env from "@mixins/environment.js"
import _api from "@mixins/api.js";
import mspConfirm from '@components/MspConfirm.vue';

const component = {
  components: {
    mspConfirm,
  },
  mixins: [
    allenamentoCalcoli,
    env,

  ],
  props: [
    'data',
    'attivita_id',
    'calendario_id',
    'sport_id',
    'utente_id',
  ],

  data: function() {
    let data = {
      loading: false,
      allenamenti: [],
      more: false,
      _id: 0
    }
    return data;
  },
  mounted () {

    this.init();
  },
  watch: {
    calendario_id: function () {
      this.update();
    },

  },
  methods: {
    update: function () {
      this.init();
    },
    setMore: function () {
      this.more = true;
      this.init();
    },
    setLess: function () {
      this.more = false;
      this.init();
    },
    classAllenamento: function (allenamento) {
      let a_classes = [];
      if (allenamento && allenamento.id === this.calendario_id) {
        a_classes.push("active");
      }

      return a_classes.join(" ");
    },

    isAssociato: function (allenamento) {
      return !!allenamento.attivita_id && allenamento.attivita_id !== this.attivita_id;
    },

    select: async function (allenamento) {
      if (this.isAssociato(allenamento)) {
        const confermato = await this.$refs.confirmAssocia.open(
          "Conferma",
          "Allenamento già associato a un'altra attività.<br>Vuoi sostituirlo?"
        );
        if (!confermato) {
          return;
        }
      }
      this.$emit("select", allenamento);
    },

      loadAllenamenti: function () {
          if (!this.data) {
              console.warn("Manca la data");

              return Promise.resolve({success: false});
          }
          const range = makeRange(this.data, this.more);
          const data = {
              da: range.da,
              a: range.a,
              sport_id: this.sport_id,
              atleta_id: this.utente_id,
              sort_dir: 'desc',
          }
          const params = this.MSP().api.URLparams(data);
          const url = this.api_base_url+"/api/v2/attivita.php?allenamenti&"+params;

          return new Promise((resolve,reject)=>{
              _api(url, "GET")
                  .then((result)=>{
                      resolve(result);
                  })
                  .catch((error)=>{
                      reject(error);
                  });
          });
      },
    init: function () {
      this.loadAllenamenti().then((result)=>{
          if(result.success) {
            this.allenamenti = result.data;
          }
        })
    }

  }

}

export default component;
</script>

<style lang="scss">

.lista-allenamenti {
  .catenella {
    margin-left: 5px;
    color: var(--col-grigio-medio);
  }
  .v-list-item {
    &.active {
      background: var(--col-ui-evidenza) !important;
      color: #fff;
    }
  }
  .more {
    margin-top: 10px;
  }
}

</style>
